import { RequestState } from '../../../types'
import { ContactsSettingsAction } from './actions'
import { Contact, ContactsSettingsState } from './store'

export const LOAD_CONTACTS_REQUEST = 'LOAD_CONTACTS_REQUEST'
export const LOAD_CONTACTS_RECEIVED = 'LOAD_CONTACTS_RECEIVED'
export const LOAD_CONTACTS_ERROR = 'LOAD_CONTACTS_ERROR'
export const REMOVE_CONTACT_REQUEST = 'REMOVE_CONTACT_REQUEST'
export const REMOVE_CONTACT_RECEIVED = 'REMOVE_CONTACT_RECEIVED'
export const REMOVE_CONTACT_ERROR = 'REMOVE_CONTACT_ERROR'
export const UPDATE_ADD_FORM_FIELD = 'UPDATE_ADD_FORM_FIELD'
export const UPDATE_ADD_FORM = 'UPDATE_ADD_FORM'
export const UPDATE_CONTACT_REQUEST = 'UPDATE_CONTACT_REQUEST'
export const UPDATE_CONTACT_RECEIVED = 'UPDATE_CONTACT_RECEIVED'
export const UPDATE_CONTACT_ERROR = 'UPDATE_CONTACT_ERROR'

export function contactsSettingsReducer(state: ContactsSettingsState, action: ContactsSettingsAction) {
  switch (action.type) {
    case LOAD_CONTACTS_REQUEST: {
      return {
        ...state,
        loadRequestState: RequestState.Loading
      }
    }

    case LOAD_CONTACTS_RECEIVED: {
      return {
        ...state,
        loadRequestState: RequestState.Loaded,
        contacts: action.contacts
      }
    }

    case LOAD_CONTACTS_ERROR: {
      return {
        ...state,
        loadRequestState: RequestState.Error
      }
    }

    case UPDATE_CONTACT_REQUEST: {
      return {
        ...state,
        form: {
          ...state.form,
          requestState: RequestState.Loading
        }

      }
    }

    case UPDATE_CONTACT_RECEIVED: {
      return {
        ...state,
        form: {
          ...state.form,
          requestState: RequestState.Loaded
        }
      }
    }

    case UPDATE_CONTACT_ERROR: {
      return {
        ...state,
        form: {
          ...state.form,
          requestState: RequestState.Error
        }
      }
    }

    case REMOVE_CONTACT_REQUEST: {
      return {
        ...state,
        contacts: state.contacts.map((contact: Contact) => {
          if (contact.id === action.contactId) {
            return {
              ...contact,
              deleteRequestState: RequestState.Loading
            }
          } else {
            return contact
          }
        })
      }
    }

    case REMOVE_CONTACT_RECEIVED: {
      return {
        ...state,
        contacts: state.contacts.filter((contact: Contact) => contact.id !== action.contactId)
      }
    }

    case REMOVE_CONTACT_ERROR: {
      return {
        ...state,
        contacts: state.contacts.map((contact: Contact) => {
          if (contact.id === action.contactId) {
            return {
              ...contact,
              deleteRequestState: RequestState.Error
            }
          } else {
            return contact
          }
        })
      }
    }

    case UPDATE_ADD_FORM_FIELD: {
      return {
        ...state,
        form: {
          ...state.form,
          contact: {
            ...state.form.contact,
            [action.field]: action.value
          }
        }
      }
    }

    case UPDATE_ADD_FORM: {
      return {
        ...state,
        form: {
          requestState: RequestState.NotLoaded,
          contact: action.contactForm
        }
      }
    }

    default: {
      return state
    }
  }
}
